// Managed via the CMS. Every entry must cite an MCC-approved source before publication.
// Current entries are drawn from MCC's own public statements and partner announcements.

export type ScholarshipStat = {
  prefix?: string;
  value: number;
  suffix?: string;
  grouped?: boolean;
  label: string;
  context: string;
};

export type ScholarshipYear = {
  year: string;
  headline: string;
  summary: string;
  recipient?: string;
  destination?: string;
  source: string;
  sourceUrl: string;
};

export const HEADLINE_STAT: ScholarshipStat = {
  prefix: "CAD $",
  value: 270500,
  grouped: true,
  label: "Highest single scholarship offer",
  context: "Received by an MCC graduate, Class of 2026.",
};

export const SUPPORTING_STATS: ScholarshipStat[] = [
  { prefix: "US$", value: 1, suffix: "M+", label: "In scholarships", context: "Awarded to MCC graduates by global institutions, 2021–22." },
  { value: 90, suffix: "%+", label: "Of graduates", context: "Received scholarship offers in the 2021–22 session." },
  { value: 12, label: "University offers", context: "Received by one MCC Scholarship recipient, 2022–23." },
];

export const SCHOLARSHIP_YEARS: ScholarshipYear[] = [
  {
    year: "2025–26",
    headline: "CAD $270,500 offer",
    summary: "The Class of 2026 turned academic results into scholarship offers at universities around the world, with the highest single offer reaching CAD $270,500.",
    source: "Maple Canadian College, 2026",
    sourceUrl: "https://www.linkedin.com/company/maple-canadian-college-lagos/",
  },
  {
    year: "2022–23",
    headline: "Maple Canadian College Scholarship",
    summary: "Awarded the MCC Scholarship to complete his OSSD at Maple, Deba went on to receive 12 offers from global universities and chose aerospace engineering at the University of Bristol.",
    recipient: "Osadebamwen (Deba) Osawaye",
    destination: "University of Bristol · Aerospace Engineering",
    source: "Rosedale Global High School, June 2023",
    sourceUrl: "https://site4.rosedaleedu.com/2023/06/29/maple-canadian-college-scholarship-winner-leverages-his-ontario-secondary-school-diploma/",
  },
  {
    year: "2021–22",
    headline: "Over US$1 million awarded",
    summary: "Over 90% of the graduating class received scholarships from institutions in Canada, the United States, the United Kingdom and beyond, totalling more than US$1 million.",
    source: "Statement by the Principal, August 2022",
    sourceUrl: "https://www.thisdaylive.com/2022/08/17/maple-canadian-college-students-get-over-1m-scholarship/",
  },
];

export const FEATURED_SCHOLAR = {
  name: "Osadebamwen (Deba) Osawaye",
  initials: "DO",
  award: "Maple Canadian College Scholarship, 2022–23",
  destination: "University of Bristol",
  programme: "Aerospace Engineering",
  story:
    "Deba knew he wanted to work with aeroplanes from the age of three. The MCC Scholarship gave him a place on the OSSD pathway at Maple, and the diploma opened doors in both the US and the UK.",
  topChoices: ["University of Bristol", "University of Illinois Urbana-Champaign", "University of Maryland"],
  otherOffers: [
    "Pennsylvania State University",
    "Purdue University Northwest",
    "University of Cincinnati",
    "University of Colorado Boulder",
    "University of Glasgow",
    "University of Minnesota",
    "University of Sheffield",
    "University of Southampton",
    "Virginia Tech",
  ],
  source: "Rosedale Global High School, June 2023",
};
